import main_config_store from "./main_config_store.js";
import flu_config_store from "./flu_config_store.js";
import map_config_store from "./map_config_store.js";
import modal_config_store from "./modal_config_store.js";
import landslide_config_store from "./landslide_config_store.js";
import timeline_config_store from './timeline_config_store.js'
import lightning_config_store from "./lightning_config_store.js";
import message_store from "./message_store.js";

const store = {
    subscribers:{},
    mainConfigStore: {...main_config_store},
    fluConfig: {...flu_config_store},
    mapConfigStore: {...map_config_store},
    modalConfigStore: {...modal_config_store},
    landslideConfigStore: {...landslide_config_store},
    timelineConfigStore: {...timeline_config_store},
    lightningConfigStore: {...lightning_config_store},
    messageStore: {...message_store},
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default store